import { HttpErrorResponse } from '@angular/common/http';
import { LanguageCode } from 'src/app/_helpers/nationalities';
import { APIErrorDetails } from 'src/app/_types/api-responses.types';

function isApiErrorDetails(value: unknown): value is APIErrorDetails {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as APIErrorDetails).clientErrorMessage === 'string'
  );
}

/**
 * Reads the error details out of either an APIResponse returned with a success status
 * or an HttpErrorResponse whose body is an APIErrorResponse.
 */
export function getApiErrorDetails(source: unknown): APIErrorDetails | null {
  const body = source instanceof HttpErrorResponse ? source.error : source;
  if (typeof body !== 'object' || body === null) return null;

  const details = (body as { error?: unknown }).error;
  return isApiErrorDetails(details) ? details : null;
}

/**
 * Message to display to the user for a failed API call: the one in the UI's language,
 * then the other one, then the caller's generic message when the API sends nothing usable.
 */
export function getApiErrorMessage(
  source: unknown,
  fallback: string,
  languageCode: LanguageCode = 'fr'
): string {
  const details = getApiErrorDetails(source);
  const french = details?.clientErrorMessageInFrench;
  const english = details?.clientErrorMessage;
  return (
    (languageCode === 'fr' ? french || english : english || french) || fallback
  );
}
